module.exports = __webpack_public_path__ + "img/9-05-koordinak.697f5e19.jpg";